import API from './servicios'
export default {
	namespaced: true,
	state: {
		cuenta: null,
		buzones: [],
		mensajes: [],
		mensaje: null,
		buzonOver: null,
		buzonActivo: null,
		pagina: null
	},
	getters: {
		cuenta (state) {
			return state.cuenta
		},
		buzones (state) {
			return state.buzones
		},
		buzonesAnidados (state) {
			if (state.buzones.length === 0) {
				return []
			}
			const buzones = []
			const analizar = (buz) => {
				const arbol = buz.buzon.split('}')[1].split('.')
				const Path = arbol.join('.')
				const Name = arbol.splice(-1, 1)[0]
				const buzon = {
					Path: Path,
					Padre: arbol.join('.'),
					Stats: buz.status,
					Name: Name,
					Nombre: null,
					Icono: null,
					Mensajes: null,
					Buzones: []
				}

				switch (buzon.Name) {
				case 'INBOX':
					buzon.Icono = 'fa fa-folder-open'
					buzon.Nombre = 'Entrada'
					break
				case 'Sent':
					buzon.Icono = 'fa fa-send'
					buzon.Nombre = 'Enviados'
					break
				case 'Junk':
					buzon.Icono = 'fa fa-bug'
					buzon.Nombre = 'Spam'
					break
				case 'Draft':
					buzon.Icono = 'fa fa-edit'
					buzon.Nombre = 'Borradores'
					break
				case 'Trash':
					buzon.Icono = 'fa fa-trash'
					buzon.Nombre = 'Papelera'
					break
				default:
					buzon.Icono = 'fa fa-folder'
					buzon.Nombre = buzon.Name
					break
				}
				buzones.push(buzon)
			}

			state.buzones.forEach(analizar)

			buzones.sort((a, b) => {
				const ba = a.Path.split('.')
				const bb = b.Path.split('.')
				if (ba.length > bb.length) {
					return 1
				} else if (ba.length < bb.length) {
					return -1
				} else {
					return 0
				}
			})

			// Ahora creamos el arbol
			for (let i = buzones.length - 1; i >= 0; i--) {
				const buz = buzones[i]

				// buscamos a su padre
				for (let p = i; p >= 0; p--) {
					if (buzones[p].Path === buz.Padre) {
						buzones[p].Buzones.push(buzones[i])
						buzones.splice(i, 1)
					}
				}
			}

			buzones.sort((a, b) => {
				if (a.Name === 'INBOX') {
					return -1
				} else if (a.Name === 'Sent') {
					return -1
				} else if (a.Name === 'Draft') {
					return -1
				} else if (a.Name === 'Trash') {
					return -1
				} else if (a.Name === 'Junk') {
					return -1
				}

				if (b.Name === 'INBOX') {
					return -1
				} else if (b.Name === 'Sent') {
					return -1
				} else if (b.Name === 'Draft') {
					return -1
				} else if (b.Name === 'Trash') {
					return -1
				} else if (b.Name === 'Junk') {
					return -1
				}

				if (a.Name > b.Name) {
					return 1
				} else if (a.Name < b.Name) {
					return -1
				} else {
					return 0
				}
			})
			return buzones
		},
		mensajes (state) {
			return state.mensajes
		},
		mensaje (state) {
			return state.mensaje
		},
		buzonOver (state) {
			return state.buzonOver
		},
		buzonActivo (state) {
			return state.buzonActivo
		},
		pagina (state) {
			return state.pagina
		}
	},
	mutations: {
		SET_CUENTA (state, email) {
			state.cuenta = email
		},
		SET_BUZONES (state, payload) {
			state.buzones = payload
		},
		SELECCIONA_BUZON (state, buzon) {
			buzon.mensajes = 0
			state.buzonActivo = buzon
			state.pagina = 1
		},
		BUZON_OVER (state, buzon) {
			state.buzonOver = buzon
		},
		SET_PAGINA (state, pagina) {
			state.pagina = pagina
		},
		SET_MENSAJES (state, mensajes) {
			state.mensajes = mensajes
		},
		SET_MENSAJE (state, mensaje) {
			state.mensaje = mensaje
		},
		SET_TOTAL_BUZON_ACTIVO (state, total) {
			state.buzonActivo.mensajes = total
		},
		SET_FLAG (state, d) {
			state.mensajes = state.mensajes.map(m => {
				if (d.numero.indexOf(m.uid) >= 0) {
					m.Flagged = d.flag
				}
				return m
			})
		},
		DEL_MENSAJE (state, uid) {
			state.mensajes = state.mensajes.filter(m => {
				return (uid.indexOf(m.uid) < 0)
			})
		},
		SET_LEIDO (state, {uid, leido}) {
			state.mensajes = state.mensajes.map(m => {
				if (uid.indexOf(m.uid) >= 0) {
					m.Recent = (leido) ? '' : m.Recent
					m.Unseen = (leido) ? '' : 'U'
				}
				return m
			})
		}
	},
	actions: {
		getListadoBuzones (context) {
			if (!context.state.cuenta) {
				console.error('No has seleccionado una cuenta')
				return
			}
			API.GetBuzones(context.state.cuenta)
				.then(listado => {
					context.commit('SET_BUZONES', listado)
				})
				.catch(e => {
					this.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e
					})
				})
		},
		getMensajes (context) {
			if (!context.state.buzonActivo) {
				return
			}
			API.GetMensajes(context.state.cuenta, context.state.buzonActivo.Path, context.state.pagina)
				.then(mensajes => {
					context.commit('SET_MENSAJES', mensajes.listado)
					context.commit('SET_TOTAL_BUZON_ACTIVO', mensajes.mensajes)
				})
				.catch(e => {
					this.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e
					})
				})
		},
		verMensaje (context, numero) {
			API.GetMensaje(context.state.cuenta, context.state.buzonActivo.Path, numero)
				.then(mensaje => {
					context.commit('SET_MENSAJE', mensaje)
					context.commit('SET_LEIDO', {uid: [numero], leido: true})
				})
				.catch(e => {
					this.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e
					})
				})
		},
		enviarPapelera (context, uid) {
			API.enviarPapelera(context.state.cuenta, context.state.buzonActivo.Path, uid)
				.then(res => {
					context.commit('DEL_MENSAJE', uid)
				})
				.catch(e => {
					this.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e
					})
				})
		},
		enviarBuzon (context, {uid, Destino}) {
			API.enviarBuzon(context.state.cuenta, context.state.buzonActivo.Path, uid, Destino)
				.then(res => {
					if (Destino !== context.state.buzonActivo.Path) {
						context.commit('DEL_MENSAJE', uid)
					}
				})
				.catch(e => {
					this.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e
					})
				})
		},
		setFlag (context, {numero, flag}) {
			API.SetFlag(context.state.cuenta, context.state.buzonActivo.Path, numero, flag)
				.then(() => {
					context.commit('SET_FLAG', {numero, flag})
				})
				.catch(e => {
					this.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e
					})
				})
		},
		setLeido (context, {numero, leido}) {
			API.SetLeido(context.state.cuenta, context.state.buzonActivo.Path, numero, leido)
				.then(() => {
					context.commit('SET_LEIDO', {uid: numero, leido: leido})
				})
				.catch(e => {
					this.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/webmail/vue/store.js